import * as React from 'react';

import { useMapServices } from './hooks';
import { MapServices } from '../../../../components/Map/parts';
import { EMapService } from '../../../../types/map';
import { trackServiceClick } from '../../analytics';
import { TransportAccessibilityOnboarding } from '../TransportAccessibilityOnboarding';

export interface IMapServicesContainerProps {
  onServiceClick: (service: EMapService) => void;
}

export const MapServicesContainer: React.FC<IMapServicesContainerProps> = ({ onServiceClick }) => {
  const serviceTypes = useMapServices();

  const handleServiceClick = React.useCallback(
    (serviceType: EMapService) => {
      if (serviceType !== EMapService.Routes) {
        trackServiceClick(serviceType);
      }

      onServiceClick(serviceType);
    },
    [onServiceClick],
  );

  return (
    <TransportAccessibilityOnboarding serviceTypes={serviceTypes}>
      <MapServices onServiceClick={handleServiceClick} serviceTypes={serviceTypes} />
    </TransportAccessibilityOnboarding>
  );
};
